<script lang="ts" setup>
import {useWootric} from '../../core/composable/useWootric';

useWootric();
</script>

<template>
    <span class="hidden" aria-hidden="true"></span>
</template>
